import type { Observable } from 'rxjs'
import { get } from '../index.js'
import { Environment } from '../../environment.js'

export type AutocompleteResponse = {
  content: string[]
  pageable: {
    size: number
    sort: unknown
    mode: 'OFFSET'
  }
  totalSize: number
}

/**
 * Suggestions per request. Sent explicitly so `page` — which the endpoint multiplies by it to get an
 * offset — can be derived from how many suggestions are already loaded.
 */
export const AUTOCOMPLETE_PAGE_SIZE = 20

export const autocompleteOrder = (data: {
  orderId?: string
  projectId?: string
  query: string
  field: string
  page: number
  blastType: string
}): Observable<AutocompleteResponse> => {
  const query = `column=${data.field}&query=${data.query}&page=${data.page}&size=${AUTOCOMPLETE_PAGE_SIZE}`
  if (data.orderId) {
    return get(
      `${Environment.API_URL}/api/orders/${data.orderId}/otu/otus/${data.blastType}/autocomplete?${query}`
    )
  } else {
    return get(`${Environment.API_URL}/api/projects/${data.projectId}/otus/${data.blastType}/autocomplete?${query}`)
  }
}
